import { IConfigurationServiceApi } from './IConfigurationServiceApi';
import { ConfigurationServiceAPIConfiguration } from '../models/ConfigurationServiceAPIConfiguration';
import { RequestUtils } from '../utils/RequestUtils';
import { CPConfigurationDto } from '../models/CPConfigurationDto';
import { DriverAppConfigurationDto } from '../models/DriverAppConfigurationDto';
import { CPConfiguration } from '../models/CPConfiguration';
import { DriverAppConfiguration } from '../models/DriverAppConfiguration';

import { Observable } from 'rxjs';

const CUSTOMER_PORTAL_ID = 'cp';
const CONTROL_TOWER_ID = 'ct';
const DRIVER_APP_ID = 'driverApp';

export class ConfigurationServiceApi implements IConfigurationServiceApi {

    constructor(private configuration: ConfigurationServiceAPIConfiguration) { }

    /**
     * Gets a customer portal configurations.
     */
    public getCustomerPortalConfigurations(): Observable<CPConfiguration[]> {
        return this.getPortalConfigurations(CUSTOMER_PORTAL_ID);
    }

    /**
     * Gets a customer portal configuration.
     */
    public getCustomerPortalConfiguration(portalId: string): Observable<CPConfiguration> {
        return this.getPortalConfiguration(CUSTOMER_PORTAL_ID, portalId);
    }

    /**
     * Gets a control tower configuration.
     */
    public getControlTowerConfiguration(portalId: string): Observable<any> {
        return this.getPortalConfiguration(CONTROL_TOWER_ID, portalId);
    }

    /**
     * Creates a customer portal configuration.
     */
    public createCustomerPortalConfiguration(portalId: string, cpConfiguration: CPConfigurationDto): Observable<CPConfiguration> {
        return this.createConfiguration(CUSTOMER_PORTAL_ID, portalId, cpConfiguration);
    }

    /**
     * Creates a driver app configuration.
     */
    public createDriverAppConfiguration(portalId:
      string,
      driverAppConfiguration:
      DriverAppConfigurationDto): Observable<DriverAppConfiguration> {
        return this.createConfiguration(DRIVER_APP_ID, portalId, driverAppConfiguration);
    }

    /**
     * Edits a customer portal configuration.
     */
    public editCustomerPortalConfiguration(portalId: string, cpConfiguration: CPConfigurationDto): Observable<CPConfiguration> {
        return this.editConfiguration(CUSTOMER_PORTAL_ID, portalId, cpConfiguration);
    }

    /**
     * Deletes a configuration.
     */
    public deleteConfiguration(appType: string, portalId: string): Observable<any> {
        const options = {
            url: this.configuration.baseUrl + this.configuration.deletePortalConfiguration.path + appType + '/' + portalId,
            method: this.configuration.deletePortalConfiguration.method,
            headers: this.configuration.deletePortalConfiguration.headers,
            json: true
        };
        return RequestUtils.promisifyRequest(options, this.configuration.httpClient);
    }

    private createConfiguration(appType: string, portalID: string, dto: any): Observable<any> {
        const options = {
            url: this.configuration.baseUrl + this.configuration.createPortalConfiguration.path + appType + '/' + portalID,
            method: this.configuration.createPortalConfiguration.method,
            headers: this.configuration.createPortalConfiguration.headers,
            body: dto,
            json: true
        };
        return RequestUtils.promisifyRequest(options, this.configuration.httpClient);
    }

    private editConfiguration(appType: string, portalID: string, dto: any): Observable<any> {
        const options = {
            url: this.configuration.baseUrl + this.configuration.editPortalConfiguration.path + appType + '/' + portalID,
            method: this.configuration.editPortalConfiguration.method,
            headers: this.configuration.editPortalConfiguration.headers,
            body: dto,
            json: true
        };
        return RequestUtils.promisifyRequest(options, this.configuration.httpClient);
    }

    private getPortalConfiguration(appType: string, portalID: string): Observable<any> {
        const options = {
            url: this.getFullUrl(this.configuration.getPortalConfiguration.path, `${appType}/${portalID}`),
            method: this.configuration.getPortalConfiguration.method,
            headers: this.configuration.getPortalConfiguration.headers,
            json: true
        };
        return RequestUtils.promisifyRequest(options, this.configuration.httpClient);
    }

    private getPortalConfigurations(appType: string): Observable<any> {
        const options = {
            url: this.getFullUrl(this.configuration.getPortalConfiguration.path, appType),
            method: this.configuration.getPortalConfiguration.method,
            headers: this.configuration.getPortalConfiguration.headers,
            json: true
        };
        return RequestUtils.promisifyRequest(options, this.configuration.httpClient);
    }

    private getFullUrl(path: string, portalType: string) {
        return `${this.configuration.baseUrl}${path}${portalType}`;
    }

}
